(function () {
  'use strict';

  if (window.__faPdpScrollGuardBooted) return;
  window.__faPdpScrollGuardBooted = true;

  var body = document.body;
  var root = document.documentElement;
  if (!body || !root) return;

  var LOCK_CLASSES = [
    'overflow-hidden',
    'overflow-hidden-mobile',
    'overflow-hidden-tablet',
    'fa-delivery-modal-open',
    'fa-country-modal-open'
  ];

  function isActuallyVisible(el) {
    if (!el || el.hidden) return false;
    if (!window.getComputedStyle) return true;

    var styles = window.getComputedStyle(el);
    return styles.display !== 'none' && styles.visibility !== 'hidden';
  }

  function isOpen(selector) {
    return isActuallyVisible(document.querySelector(selector));
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function isCartDrawerOpen() {
    var drawer = getCartDrawer();
    return !!(drawer && drawer.classList.contains('active') && isActuallyVisible(drawer));
  }

  function isHeaderDrawerOpen() {
    return !!document.querySelector('header-drawer details[open], menu-drawer details[open]');
  }

  function isProductModalOpen() {
    return !!document.querySelector('product-modal[open], modal-dialog[open], quick-add-modal[open]');
  }

  function shouldStayLocked() {
    return (
      isOpen('[data-fa-delivery-modal]') ||
      isOpen('[data-fa-country-modal]') ||
      isCartDrawerOpen() ||
      isHeaderDrawerOpen() ||
      isProductModalOpen()
    );
  }

  function clearKnownLocks() {
    LOCK_CLASSES.forEach(function (className) {
      body.classList.remove(className);
      root.classList.remove(className);
    });
  }

  function syncCartDrawerHitTesting() {
    var drawer = getCartDrawer();
    if (!drawer) return;

    if (drawer.classList.contains('active') && isActuallyVisible(drawer)) {
      if (drawer.style.pointerEvents === 'none') drawer.style.removeProperty('pointer-events');
    } else if (drawer.style.pointerEvents !== 'none') {
      drawer.style.setProperty('pointer-events', 'none');
    }
  }

  function syncKnownModalHitTesting(selector) {
    var modal = document.querySelector(selector);
    if (!modal) return;

    if (isActuallyVisible(modal)) {
      if (modal.style.pointerEvents === 'none') modal.style.removeProperty('pointer-events');
    } else if (modal.style.pointerEvents !== 'none') {
      modal.style.setProperty('pointer-events', 'none');
    }
  }

  function syncTransientHitTesting() {
    syncCartDrawerHitTesting();
    syncKnownModalHitTesting('[data-fa-delivery-modal]');
    syncKnownModalHitTesting('[data-fa-country-modal]');
  }

  function hideKnownModal(selector) {
    var modal = document.querySelector(selector);
    if (!modal) return;
    modal.hidden = true;
  }

  function closeOpenDawnModals() {
    var modals = document.querySelectorAll('product-modal[open], modal-dialog[open], quick-add-modal[open]');

    modals.forEach(function (modal) {
      try {
        if (typeof modal.hide === 'function') {
          modal.hide();
          return;
        }
      } catch (_) {}

      modal.removeAttribute('open');
    });
  }

  function resetTransientUi() {
    hideKnownModal('[data-fa-delivery-modal]');
    hideKnownModal('[data-fa-country-modal]');
    closeOpenDawnModals();

    var drawer = getCartDrawer();
    if (drawer && drawer.classList.contains('active')) {
      try {
        if (typeof drawer.close === 'function') {
          drawer.close();
        } else {
          drawer.classList.remove('active');
        }
      } catch (_) {
        drawer.classList.remove('active');
      }
    }

    var main = document.getElementById('MainContent');
    if (main) main.removeAttribute('inert');

    clearKnownLocks();
    syncTransientHitTesting();
  }

  function reconcile() {
    syncTransientHitTesting();
    if (shouldStayLocked()) return;
    clearKnownLocks();
  }

  var scheduled = false;
  function scheduleReconcile() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      reconcile();
    });
  }

  function observeTransientUi() {
    var observer = new MutationObserver(scheduleReconcile);

    observer.observe(body, {
      attributes: true,
      attributeFilter: ['class']
    });

    var drawer = getCartDrawer();
    if (drawer) {
      observer.observe(drawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    ['[data-fa-delivery-modal]', '[data-fa-country-modal]'].forEach(function (selector) {
      var modal = document.querySelector(selector);
      if (modal) {
        observer.observe(modal, {
          attributes: true,
          attributeFilter: ['hidden', 'class']
        });
      }
    });
  }

  function isBackForwardNavigation(event) {
    if (event && event.persisted) return true;
    if (!window.performance || !window.performance.getEntriesByType) return false;

    var navigation = window.performance.getEntriesByType('navigation')[0];
    return !!(navigation && navigation.type === 'back_forward');
  }

  document.addEventListener('touchend', scheduleReconcile, { passive: true });
  document.addEventListener('click', scheduleReconcile, true);

  window.addEventListener('pagehide', function () {
    // Keep transient overlays out of the browser back-forward cache.
    resetTransientUi();
  });

  window.addEventListener('pageshow', function (event) {
    if (isBackForwardNavigation(event)) {
      resetTransientUi();
    }

    // Mobile browsers can restore custom-element state a little after pageshow.
    scheduleReconcile();
    window.setTimeout(scheduleReconcile, 120);
    window.setTimeout(scheduleReconcile, 400);
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) scheduleReconcile();
  });

  observeTransientUi();
  syncTransientHitTesting();
  scheduleReconcile();
})();
